import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

// ═══════════════ DRIVER POINTS SUMMARY ═══════════════
// Returns { summary, ledger, financialYear } for the calling driver
// (or for any driver if caller is admin and passes driverId).
export async function getDriverPointsSummary(opts = {}) {
  const fn = httpsCallable(functions, 'getDriverPointsSummary');
  const result = await fn(opts || {});
  return result.data;
}

// ═══════════════ VALIDATE REFERRAL CODE (signup-time, no auth needed) ═══════════════
// Returns { valid, reason?, driverDisplayName? }
export async function validateReferralCode(code) {
  if (!code || !code.trim()) return { valid: false, reason: 'Code is empty.' };
  const fn = httpsCallable(functions, 'validateReferralCode');
  const result = await fn({ code: code.trim().toUpperCase() });
  return result.data;
}

// ═══════════════ USE REFERRAL CODE AT SIGNUP (post-auth, soft-fail) ═══════════════
// Called from AuthContext.registerRider after the user doc exists.
// Returns { success, reason?, referralId? }
// Does NOT throw — registration must not fail over a referral typo.
export async function useReferralCodeAtSignup(code) {
  if (!code || !code.trim()) return { success: false, reason: 'no_code_provided' };
  const fn = httpsCallable(functions, 'useReferralCodeAtSignup');
  try {
    const result = await fn({ code: code.trim().toUpperCase() });
    return result.data;
  } catch (err) {
    console.warn('useReferralCodeAtSignup failed (non-fatal):', err.message);
    return { success: false, reason: 'rpc_error' };
  }
}

// ═══════════════ DISTRIBUTION PREVIEW (admin) ═══════════════
// Returns full preview object: pool, drivers list with shares, totalAllocated, remainder.
export async function getDistributionPreview({ financialYear, netProfitAUD, sharePercent }) {
  const fn = httpsCallable(functions, 'getDistributionPreview');
  const result = await fn({ financialYear, netProfitAUD, sharePercent });
  return result.data;
}

// ═══════════════ EXECUTE ANNUAL DISTRIBUTION (super-admin only) ═══════════════
// Requires typedConfirmation === 'DISTRIBUTE'. Idempotent per FY.
// Returns { success, financialYear, poolAUD, totalDistributedAUD, eligibleDriverCount, remainderAUD }
export async function executeAnnualDistribution({ financialYear, netProfitAUD, sharePercent, typedConfirmation }) {
  const fn = httpsCallable(functions, 'executeAnnualDistribution');
  const result = await fn({ financialYear, netProfitAUD, sharePercent, typedConfirmation });
  return result.data;
}